// extracted by mini-css-extract-plugin
module.exports = {"header":"infoRP_header__t_4gJ","image-wrapper":"infoRP_image-wrapper__Lxyus"};